class EventsService {
    static isDev () {
        return GLOBALS.is_dev
    }

    static sendEvent (name, args = {}) {
        window.dataLayer = window.dataLayer || []
        const data = Object.assign(
            {
                event: name,
            },
            args
        )
        
        if (EventsService.isDev()) {
            console.log('data sent', data)
        } else {
            window.dataLayer.push(data)
        }
    }
}

export default EventsService
